import { render, staticRenderFns } from "./PendencyService.vue?vue&type=template&id=647484f4&scoped=true&"
import script from "./PendencyService.vue?vue&type=script&lang=js&"
export * from "./PendencyService.vue?vue&type=script&lang=js&"
import style0 from "./PendencyService.vue?vue&type=style&index=0&id=647484f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647484f4",
  null
  
)

export default component.exports